import { CRUDPathSegmentEn } from '../../newFeatures/crudPathSegment.enum';

const deliveryPath = {
  deliveryManagement: '/erp/contract-execution/delivery',
  // Delivery order - DS yêu cầu giao hàng
  deliveryOrder: '/erp/contract-execution/delivery/delivery-order',
  deliveryOrderDetail: '/erp/contract-execution/delivery/delivery-order' + CRUDPathSegmentEn.DETAIL,
  // deliveryOrderDetailCode: '/erp/contract-execution/delivery/delivery-order' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  deliveryOrderAdd: '/erp/contract-execution/delivery/delivery-order' + CRUDPathSegmentEn.ADD,
  deliveryOrderEdit: '/erp/contract-execution/delivery/delivery-order' + CRUDPathSegmentEn.EDIT,

  // Delivery request - Lệnh giao hàng
  deliveryRequest: '/erp/contract-execution/delivery/delivery-request',
  deliveryRequestDetail: '/erp/contract-execution/delivery/delivery-request' + CRUDPathSegmentEn.DETAIL,
  deliveryRequestDetailCode: '/erp/contract-execution/delivery/delivery-request' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  deliveryRequestAdd: '/erp/contract-execution/delivery/delivery-request' + CRUDPathSegmentEn.ADD,
  deliveryRequestEdit: '/erp/contract-execution/delivery/delivery-request' + CRUDPathSegmentEn.EDIT,

  // Incoterm - Điều khoản thương mại
  incoterm: '/erp/contract-execution/delivery/master-data/incoterm',
  incotermDetail: '/erp/contract-execution/delivery/master-data/incoterm' + CRUDPathSegmentEn.DETAIL,
  incotermDetailCode: '/erp/contract-execution/delivery/master-data/incoterm' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  incotermAdd: '/erp/contract-execution/delivery/master-data/incoterm' + CRUDPathSegmentEn.ADD,
  incotermEdit: '/erp/contract-execution/delivery/master-data/incoterm' + CRUDPathSegmentEn.EDIT,

  // Payment method - Hình thức thanh toán
  tradePaymentMethod: '/erp/contract-execution/delivery/master-data/trade-payment-method',
  tradePaymentMethodDetail:
    '/erp/contract-execution/delivery/master-data/trade-payment-method' + CRUDPathSegmentEn.DETAIL,
  tradePaymentMethodDetailCode:
    '/erp/contract-execution/delivery/master-data/trade-payment-method' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  tradePaymentMethodAdd: '/erp/contract-execution/delivery/master-data/trade-payment-method' + CRUDPathSegmentEn.ADD,
  tradePaymentMethodEdit: '/erp/contract-execution/delivery/master-data/trade-payment-method' + CRUDPathSegmentEn.EDIT,

  // Main Shipping method - Phương tiện vận chuyển chính
  mainShippingMethod: '/erp/contract-execution/delivery/master-data/main-shipping-method',
  mainShippingMethodDetail:
    '/erp/contract-execution/delivery/master-data/main-shipping-method' + CRUDPathSegmentEn.DETAIL,
  mainShippingMethodDetailCode:
    '/erp/contract-execution/delivery/master-data/main-shipping-method' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  mainShippingMethodAdd: '/erp/contract-execution/delivery/master-data/main-shipping-method' + CRUDPathSegmentEn.ADD,
  mainShippingMethodEdit: '/erp/contract-execution/delivery/master-data/main-shipping-method' + CRUDPathSegmentEn.EDIT,

  // Shipping Stage - Chặng vận chuyển
  shippingStage: '/erp/contract-execution/delivery/master-data/shipping-stage',
  shippingStageDetail: '/erp/contract-execution/delivery/master-data/shipping-stage' + CRUDPathSegmentEn.DETAIL,
  shippingStageDetailCode:
    '/erp/contract-execution/delivery/master-data/shipping-stage' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  shippingStageAdd: '/erp/contract-execution/delivery/master-data/shipping-stage' + CRUDPathSegmentEn.ADD,
  shippingStageEdit: '/erp/contract-execution/delivery/master-data/shipping-stage' + CRUDPathSegmentEn.EDIT,

  // Payment document - Chứng từ thanh toán
  paymentDocument: '/erp/contract-execution/delivery/master-data/payment-document',
  paymentDocumentDetail: '/erp/contract-execution/delivery/master-data/payment-document' + CRUDPathSegmentEn.DETAIL,
  paymentDocumentDetailCode:
    '/erp/contract-execution/delivery/master-data/payment-document' + CRUDPathSegmentEn.DETAIL_BY_CODE,
  paymentDocumentAdd: '/erp/contract-execution/delivery/master-data/payment-document' + CRUDPathSegmentEn.ADD,
  paymentDocumentEdit: '/erp/contract-execution/delivery/master-data/payment-document' + CRUDPathSegmentEn.EDIT,

  // Payment document detail requirement - Yêu cầu chi tiết cho chứng từ
  paymentDocumentDetailRequirement: '/erp/contract-execution/delivery/master-data/payment-document-detail-requirement',
  paymentDocumentDetailRequirementDetail:
    '/erp/contract-execution/delivery/master-data/payment-document-detail-requirement' + CRUDPathSegmentEn.DETAIL,
  paymentDocumentDetailRequirementDetailCode:
    '/erp/contract-execution/delivery/master-data/payment-document-detail-requirement' +
    CRUDPathSegmentEn.DETAIL_BY_CODE,
  paymentDocumentDetailRequirementAdd:
    '/erp/contract-execution/delivery/master-data/payment-document-detail-requirement' + CRUDPathSegmentEn.ADD,
  paymentDocumentDetailRequirementEdit:
    '/erp/contract-execution/delivery/master-data/payment-document-detail-requirement' + CRUDPathSegmentEn.EDIT,

  // International Trade Agreement  - Điều ước quốc tế, pháp luật và tập quán thương mại quốc tế
  internationalTradeAgreement: '/erp/contract-execution/delivery/master-data/international-trade-agreement',
  internationalTradeAgreementDetail:
    '/erp/contract-execution/delivery/master-data/international-trade-agreement' + CRUDPathSegmentEn.DETAIL,
  internationalTradeAgreementAdd:
    '/erp/contract-execution/delivery/master-data/international-trade-agreement' + CRUDPathSegmentEn.ADD,
  internationalTradeAgreementEdit:
    '/erp/contract-execution/delivery/master-data/international-trade-agreement' + CRUDPathSegmentEn.EDIT
};
export default deliveryPath;
